import React from 'react';
import Link from '@material-ui/core/Link';
import t from 'prop-types';

const MailLinkCell = ({value}) => <Link href={`mailto:${value}`}>{value}</Link>;
MailLinkCell.propTypes = {
  value: t.string,
};

export default MailLinkCell;
